import { render, staticRenderFns } from "./ForwardedRequestsModal.vue?vue&type=template&id=61fd094e&"
import script from "./ForwardedRequestsModal.vue?vue&type=script&lang=js&"
export * from "./ForwardedRequestsModal.vue?vue&type=script&lang=js&"
import style0 from "./ForwardedRequestsModal.vue?vue&type=style&index=0&id=61fd094e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports